{
  "SMS_REGISTRATION": {
    "ALERT": {
      "BUSINESS_INFO_REQUIRED_TITLE": "Business information required",
      "MORE_DETAILS_SUGGESTION": "More details are needed about your business to send SMS messages to customers.",
      "UPDATE_INFO_ACTION_TITLE": "Update business info",
      "REJECTED_TITLE": "SMS registration rejected",
      "REJECTED_SUGGESTION": "update your information and try submitting again to access SMS features."
    },
    "CARD": {
      "YOUR_SMS_NUMBER": "Your SMS number",
      "ASSIGNED_NUMBER_TITLE": "Assigned Number",
      "ASSIGNED_NUMBER_DESCRIPTION": "Your number is automatically assigned based on available options in your area."
    },
    "INFO_BANNER": {
      "LEARN_MORE": "Learn more"
    }
  }
}
